export type StatusWithLabel<E> = { label: string, value: E }
export type TypesWithLabel<E> = { text: string, value: E }

export const getStatuses = (enumObject: Object): string[] => {
  const keys = Object.keys(enumObject);

  return keys.slice(0, keys.length / 2);
};
